module.exports = __webpack_public_path__ + "static/scale-model-of-guthrie-green-in-tulsa-oklahoma-4722967880867299500fa86fd20eb76c.png";